export const COMPANY_LOOKUP = gql`
    query companyLookup($companyName: String, $companyNumber: String) {
        companyLookUp(companyName: $companyName, companyNumber: $companyNumber) {
            companyName
            registrationNumber
            companyBusinessIndicator
            companyTypeDescription
        }
    }
`;
